<div class="c-buttons-top">
  <div class="text-right">
    <div class="checkout-cart-action" (click)="emptyCart()">
      <span translate>EMPTY_CART</span>
      <i class="fas fa-trash-alt"></i>
    </div>
    <div class="checkout-cart-action" (click)="saveCart()">
      <span translate>SAVE_CART</span>
      <i class="fas fa-save"></i>
    </div>
  </div>
</div>
